import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';
import { set, setMulti,setOpenAdvanceFiltersDialog } from '../../../store/actions/pages';

import ClaimAnalysisTopFiltersComponent from './ClaimAnalysisTopFilters';
import { setRelativeFilter } from '../../../store/actions/claimAnalysis';

export const ClaimAnalysisTopFilters = connect(
    () => {
        const selectPending = createSelector(
            (state) => state.pages,
            (state) => state.search.getByName.pending,
            (pages, searchPending) => {
                return pages['claimAnalysis-landing'].pending || searchPending
            }
        );

        return (state:any, props) => ({
            relativeFilterValue: state.claimAnalysis.relativeFilterValue,
            pageState:state.pages['claimAnalysis-landing'],
            ignoreDueToQuickSearch:state.pages['claimAnalysis-landing']?.ignoreAcknowledgement,
            pending: selectPending(state),
            open: state.pages.open
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            set: (value) => set('claimAnalysis-landing', 'significance', value),
            setMulti: obj => setMulti('claimAnalysis-landing', obj),
            setCustomFilter: (value) => set('claimAnalysis-landing', 'customFilter', value),
            setRelativeFilter: setRelativeFilter,
            setOpenAdvanceFiltersDialog
        }, dispatch)
    })
)(injectIntl(ClaimAnalysisTopFiltersComponent));